import React, { useState, useEffect } from 'react';

import Card from '~/components/Card';
import { Form, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchKeywordApi, deleteKeywordApi, toggleKeywordPublishedStateApi } from './keywordSlice.js';
import EditDeleteBtn from '~/components/EditDeleteBtn';
import { titleCase } from '~/utils/helpers';
import KeywordFormModal from './KeywordFormModal.jsx';
import Datatable from '~/components/Datatable';

function Keyword() {
    const [showModal, setShowModal] = useState(false);
    const [editedRow, setEditedRow] = useState({});

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { rows } = useSelector((state) => state.cardSaga.keyword);
    const columns = React.useMemo(
        () => [
            {
                name: '#',
                selector: (row) => row.id,
                sortable: true,
            },
            {
                name: titleCase('name'),
                selector: (row) => titleCase(row.name),
                sortable: true,
            },
            {
                name: 'Edit/Remove',
                cell: (row) => (
                    <EditDeleteBtn
                        row={row}
                        thunkFunc={deleteKeywordApi}
                        withoutNavigation={true}
                        setShowModal={setShowModal}
                        setEditedRow={setEditedRow}
                    />
                ),
            },
            {
                name: 'Published',
                cell: (row) => (
                    <Form.Check
                        type="switch"
                        id={'published-' + row.id}
                        onChange={() => {
                            dispatch(toggleKeywordPublishedStateApi(row.id));
                        }}
                        checked={row.is_ready}
                    />
                ),
            },
        ],
        [],
    );

    useEffect(() => {
        if (rows.length > 0) return;
        dispatch(fetchKeywordApi(navigate));
    }, []);

    return (
        <Card>
            <div className={'d-flex flex-row-reverse'}>
                <Button
                    className={'bg-info border border-info'}
                    onClick={() => setShowModal(true)}
                >
                    Create
                </Button>
            </div>
            <div className="col-sm-6 offset-sm-3">
                <Datatable
                    columns={columns}
                    rows={rows}
                />
            </div>
            <KeywordFormModal
                showModal={showModal}
                setShowModal={setShowModal}
                editedRow={editedRow}
                setEditedRow={setEditedRow}
            />
        </Card>
    );
}

export default Keyword;
//ref: https://codesandbox.io/s/react-bootstrap-formik-pb831?from-embed=&file=/src/form-section-1.js:436-570
/**Notes */
//(1) even though this is reset button, don't use type="reset" here as it will cause nested form fields (like FormikArray) unable to be reset to its initial values (I debugged and figured it out).
